import { configureStore } from "@reduxjs/toolkit";
import rootReducers from "./reducers/index";

// creating store
export const store = configureStore({
  reducer: rootReducers,
});
